import { styled } from '@mui/material/styles'
import type { VoucherBannerVariant } from '../../../../VoucherBanner.types'

const STEP_ICON_COLOR: Record<VoucherBannerVariant, string> = {
  smava: 'rgba(197, 232, 199, 1)',
  ffg: '#E8EEF5'
}

export const StepIcon = styled('svg', {
  shouldForwardProp: (prop) => prop !== 'variant'
})<{ variant: VoucherBannerVariant }>(({ variant }) => ({
  flex: '0 0 18px',
  width: 18,
  height: 18,
  color: STEP_ICON_COLOR[variant]
}))
